import { useTranslation } from "react-i18next";
import StoreBadges from "../../../components/ui/StoreBadges";

function QASection() {
  const { t } = useTranslation();
  const questions = [
    t("qa.question1"),
    t("qa.question2"),
    t("qa.question3"),
    t("qa.question4"),
    t("qa.question5"),
  ];

  return (
    <div className="block sm:hidden bg-black">
      <section id="qasection">
        <div className="text-white relative w-[90%] sm:w-[100%] mx-auto my-36">
          <div className="qa-container">
            <div className="qa-head text-center rounded-lg sm:absolute sm:top-[50%] sm:left-[50%] sm:transform sm:-translate-x-1/2 sm:-translate-y-1/2 sm:bg-customPurple-light/80 sm:backdrop-blur-xs sm:p-10">
              <div className="qa-title text-4xl font-euc">
                <h2>{t("qa.title")}</h2>
              </div>
              <br />
              <StoreBadges />
            </div>
            <div className="qa-content pt-8 flex justify-center flex-col sm:flex-row">
              {questions.map((question) => (
                <div
                  key={question}
                  className="qa-box my-2 w-[100%] sm:w-[20%] items-center justify-center border border-customPurple shadow-custom-4-sided shadow-customPurple sm:shadow-customWhite rounded-xl mx-auto p-3 flex flex-col text-center"
                >
                  <div className="qa-box-title my-2 text-2xl">{question}</div>
                </div>
              ))}
            </div>
            <div className="qa-content hidden sm:flex justify-center flex-col sm:flex-row">
              {questions.map((question) => (
                <div
                  key={`${question}-desktop`}
                  className="qa-box my-2 w-[100%] sm:w-[20%] items-center justify-center border border-customPurple shadow-custom-4-sided shadow-customPurple sm:shadow-customWhite rounded-xl mx-auto p-3 flex flex-col text-center"
                >
                  <div className="qa-box-title my-2 text-2xl">{question}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default QASection;
